var React = require('react');

function ResourceMediumPresentationInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.19727 11V13.6573","stroke":"#717171","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M4.09961 14H11.9529","stroke":"#717171","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("rect",{"x":"0.6","y":"0.6","width":"15.1894","height":"10.4092","rx":"2.02487","stroke":"#717171","strokeWidth":"1.2","key":2})]);
}

ResourceMediumPresentationInline.defaultProps = {"width":"17","height":"15","viewBox":"0 0 17 15","fill":"none"};

module.exports = ResourceMediumPresentationInline;

ResourceMediumPresentationInline.default = ResourceMediumPresentationInline;
